import { translateHelper } from "../translateHelper"

export const translateMessage = (key: string) =>
  translateHelper.translateMessage(key) || ""
